import fetchMerchandiseHeroPromos from 'actions/merchandise/fetchMerchandiseHeroPromos'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { EmptyArray } from 'lib/array/arrayUtils'
import { useEffect } from 'react'

type ReturnType = [
  Array<App.MerchandiseHeroPromo>,
  boolean,
  any,
]

function useMerchandiseHeroPromos(): ReturnType {
  const dispatch = useAppDispatch()

  const heroPromos = useAppSelector(state => state.merchandise.merchandiseHeroPromos)
  useEffect(() => {
    dispatch(fetchMerchandiseHeroPromos())
  }, [dispatch])

  return [
    heroPromos?.heroPromos ?? EmptyArray,
    heroPromos?.fetching ?? false,
    heroPromos?.error,
  ]
}

export default useMerchandiseHeroPromos
